module.exports = __webpack_public_path__ + "img/resolute.790b7ee1.png";